import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  CardMedia,
  CardContent,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { config } from "../../config/config";
import { apiList, invokeApi } from "../../services/apiServices";
import image from "../../assets/home-project.jpg";

// Removed static filmsData


export default function FilmsSection() {
  const containerRef = useRef(null);
  const [bgSize, setBgSize] = useState(110);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [films, setFilms] = useState([]);

  useEffect(() => {
    const fetchFilms = async () => {
      try {
        const response = await invokeApi(
          config.getMyCollege + apiList.getFilms,
          null,
          "POST",
          {},
          { "Content-Type": "application/json" }
        );

        if (response?.status === 200) {
          const responseData = response.data;
          let allFilms = [];

          if (Array.isArray(responseData.films)) {
            allFilms = responseData.films;
          }
          console.log("Films Data:", allFilms);
          setFilms(allFilms);
        } else {
          console.error("Failed to fetch films:", response);
        }
      } catch (error) {
        console.error("Error fetching films:", error);
      }
    };

    fetchFilms();

    const handleScroll = () => {
      if (containerRef.current) {
        const { top, height } = containerRef.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        const scrollProgress = Math.min(
          Math.max((windowHeight - top) / (windowHeight + height), 0),
          1
        );

        const newSize = 110 - scrollProgress * 10;
        setBgSize(newSize);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box
      ref={containerRef}
      sx={{
        width: "100%",
        height: { xs: "350px", sm: "650px", md: "500px" },
        position: "relative",
        overflow: "hidden",
        backgroundImage: `url(${image})`,
        backgroundAttachment: "fixed",
        backgroundSize: `${bgSize}%`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        transition: "background-size 0.3s ease",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        pt: { xs: 3, md: 6 },
        pb: { xs: 3.5, md: 4 },
      }}
    >
      {/* Gradient Overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(to right, rgba(0,0,0,0.85) 40%, transparent)",
          zIndex: 1,
        }}
      />

      {/* Content */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          width: "90%",
          maxWidth: 1400,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          color: "white",
          userSelect: "none",
          height: "100%",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant={isMobile ? "h4" : "h3"}
          sx={{
            fontWeight: "bold",
            fontFamily: "Montserrat, sans-serif",
            textTransform: "uppercase",
            letterSpacing: 2,
          }}
        >
          Films
        </Typography>

        {/* <Box
          sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
        >
          <Button
            variant="outlined"
            endIcon={<ArrowForwardIcon />}
            sx={{
              borderColor: "white",
              fontFamily: "Montserrat, sans-serif",
              color: "white",
              textTransform: "uppercase",
              px: 3,
              fontWeight: "bold",
              "&:hover": {
                borderColor: "white",
                backgroundColor: "rgba(255,255,255,0.1)",
              },
            }}
          >
            Explore
          </Button>
        </Box> */}

        {/* Carousel */}
        <Box
          sx={{
            width: "100%",
            maxWidth: 1000,
            mx: "auto",
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
          }}
        >
          <>
            <Swiper
              spaceBetween={20}
              pagination={{ clickable: true }}
              modules={[Pagination]}
              slidesPerView={
                films.length < 3 ? films.length : isMobile ? 1.2 : 3
              }
              style={{
                paddingBottom: 50,
                width: "100%",
                display: "flex",
                justifyContent:
                  films.length === 1 ? "center" : "flex-start",
              }}
            >
              {films.map((film, index) => (
                <SwiperSlide
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <a
                    href={film.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    <Card
                      sx={{
                        width: isMobile ? 250 : 340,
                        height: 260,
                        boxShadow: 5,
                        position: "relative",
                        borderRadius: 2,
                        cursor: "pointer",
                        transition: "transform 0.3s ease",
                        "&:hover": {
                          transform: "scale(1.05)",
                          boxShadow: 10,
                        },
                      }}
                      elevation={6}
                    >
                      <CardMedia
                        component="img"
                        image={film.image || "/default-film.jpg"}
                        alt={film.title}
                        sx={{
                          height: isMobile ? 200 : 260,
                          width: "100%",
                          objectFit: "cover",
                        }}
                      />
                      <CardContent
                        sx={{
                          position: "absolute",
                          bottom: 0,
                          width: "100%",
                          background: "rgba(0, 0, 0, 0.7)",
                          color: "white",
                          fontWeight: "bold",
                          fontFamily: "Montserrat, sans-serif",
                          px: 2,
                          py: 1,
                          fontSize: isMobile ? "1rem" : "1.1rem",
                          userSelect: "none",
                        }}
                      >
                        {film.title || film.name}
                      </CardContent>
                    </Card>
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* ✅ Inject Swiper bullet styles */}
            <style>
              {`
    .swiper-pagination-bullet {
      background-color: white;
      opacity: 0.7;
    }

    .swiper-pagination-bullet-active {
      background-color: #21c2e2;
      opacity: 1;
    }
  `}
            </style>
          </>
        </Box>
      </Box>
    </Box>
  );
}
